/**
 * Login container.
 * @module components/theme/ViewXml/ViewXml
 */

import React, { useEffect } from 'react';

import { defineMessages, useIntl } from 'react-intl';
import { Grid } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet, BodyClass } from '@plone/volto/helpers';
import { getYCApi } from '@package/actions';
import { useDispatch, useSelector } from 'react-redux';
import { UniversalLink } from '@plone/volto/components';

const messages = defineMessages({
  scheda_pdd: {
    id: 'scheda_pdd',
    defaultMessage: 'Scheda Punto di distribuzione',
  },
  from: {
    id: 'from',
    defaultMessage: 'dal',
  },
  to: {
    id: 'to',
    defaultMessage: 'al',
  },
  tipologia: { id: 'yc_tipologia', defaultMessage: 'Tipologia:' },
  target: { id: 'yc_target', defaultMessage: 'Target:' },
  dotazioni: { id: 'yc_dotazioni', defaultMessage: 'Dotazioni:' },
  servizi: { id: 'yc_servizi', defaultMessage: 'Servizi:' },
});
/**
 * ViewXml class.
 * @class ViewXml
 * @extends Component
 */

const YCPuntoDistribuzioneView = (props) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const itemID = props?.match?.params?.[2];

  useEffect(() => {
    if (itemID) {
      dispatch(getYCApi(itemID, 'distribuzione', { id: itemID }));
    }
  }, [dispatch, itemID]);

  const content = useSelector(
    (state) => state.YCApi.subrequests?.[itemID + 'distribuzione']?.result,
  );

  return (
    <div id="page-ycview" className="ui container">
      <Helmet title={content?.DS01_NOME} />
      {/* Body class if displayName in component is set */}
      <BodyClass className={`view-ycspazio`} />
      {/*-----titolo-----*/}
      {content?.DS01_NOME && (
        <h1 className="documentFirstHeading">{content.DS01_NOME}</h1>
      )}

      <Grid className="data">
        <Grid.Row stretched>
          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={8}
            widescreen={8}
          >
            <div>
              {/*-----descrizione-----*/}
              {content?.DS01_DESCRIZIONE && (
                <div className="description">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: content.DS01_DESCRIZIONE.replaceAll(
                        '\r\n',
                        '<br/>',
                      ).replace('\n', '<br/>'),
                    }}
                  ></p>
                </div>
              )}

              {/*-----note-----*/}
              {content?.DS01_NOTE && (
                <div className="description">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: content.DS01_NOTE.replaceAll(
                        '\r\n',
                        '<br/>',
                      ).replace('\n', '<br/>'),
                    }}
                  ></p>
                </div>
              )}
            </div>
          </Grid.Column>

          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={4}
            widescreen={4}
            className="column-infos"
          >
            {/*-----info-----*/}
            <div className="infos-header">
              {intl.formatMessage(messages.scheda_pdd)}
            </div>

            <div className="infos-body">
              <div className="info">
                <span className="label">
                  <FontAwesomeIcon icon={['fas', 'map-marker-alt']} />
                </span>
                <span>
                  {content?.DS01_INDIRIZZO}
                  {content?.DS01_CIVICO ? ', ' + content?.DS01_CIVICO : ''}
                  <br />
                  {content?.DS01_CAP ? content?.DS01_CAP + ' ' : ''}{' '}
                  {content?.DS01_LOCALITA ? content?.DS01_LOCALITA + ' ' : ''}{' '}
                  {content?.DS01_COMUNE ? content?.DS01_COMUNE + ' ' : ''}{' '}
                  {content?.DS01_PROVINCIA
                    ? '(' + content?.DS01_PROVINCIA + ') '
                    : ''}
                </span>
              </div>

              {(content?.DS01_TELEFONO ||
                content?.DS01_WEB ||
                content?.DS01_MAIL) && (
                <div className="info contact-infos">
                  {content?.DS01_WEB && (
                    <span>
                      <UniversalLink href={content.DS01_WEB}>
                        {content.DS01_WEB}
                      </UniversalLink>
                    </span>
                  )}

                  {content?.DS01_MAIL && (
                    <span>
                      <a href={`mailto:${content.DS01_MAIL}`}>
                        {content.DS01_MAIL}
                      </a>
                    </span>
                  )}
                  {content?.DS01_TELEFONO && (
                    <span>
                      <a href={'tel:' + content?.DS01_TELEFONO}>
                        {content?.DS01_TELEFONO}
                      </a>
                    </span>
                  )}
                </div>
              )}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default YCPuntoDistribuzioneView;
